export default import.meta.ROLLDOWN_FILE_URL_VWwheoQHW_e8UcRiND$XOg